import TinyEditorComponent from './containers/tinyEditorComponent'

export { default as TinyEditorLayout } from './components/tinyEditorLayout' 

export default TinyEditorComponent